

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETALLALLQUESTIONS= createAsyncThunk(
  "getAllQuestions/getAllQuestions",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllQuestionsSlice = createSlice({
  name: "getAllQuestionsSlice",
  initialState: {
    getAllQuestions: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllQuestions: (state) => {
        state.getAllQuestions.loading = false
        state.getAllQuestions.error = false
        state.getAllQuestions.data = []
        state.getAllQuestions.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLALLQUESTIONS.fulfilled, (state, action) => {
      state.getAllQuestions = {
        ...state.getAllQuestions,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLALLQUESTIONS.pending, (state, action) => {
      state.getAllQuestions = {
        ...state.getAllQuestions,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLALLQUESTIONS.rejected, (state, action) => {
      state.getAllQuestions = {
        ...state.getAllQuestions,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllQuestionsAction = {
    GETALLALLQUESTIONS,
};

export { getAllQuestionsAction };
export default getAllQuestionsSlice.reducer;
export const {setInitialStateOfgetAllQuestions} = getAllQuestionsSlice.actions
